import palette from "./palette";

// import breakpoints from "./breakpoints";

export default {
  fontSize: 10,
  // Tell Material-UI what's the font-size on the html element is.
  htmlFontSize: 10,
  // fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
  h1: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: "3.5rem",
    letterSpacing: "-0.24px",
    lineHeight: 4.0,
  },
  h2: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: "2.9rem",
    letterSpacing: "-0.24px",
    lineHeight: 3.2,
  },
  h3: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: "2.4rem",
    letterSpacing: "-0.06px",
    lineHeight: 2.8,
  },
  h4: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: "2.0rem",
    letterSpacing: "-0.06px",
    lineHeight: 2.4,
  },
  h5: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: "1.6rem",
    letterSpacing: "-0.05px",
    lineHeight: 2.0,
  },
  h6: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: "1.4rem",
    letterSpacing: "-0.05px",
    lineHeight: 2.0,
  },
  subtitle1: {
    color: palette.text.primary,
    fontSize: "1.6rem",
    letterSpacing: "-0.05px",
    lineHeight: 2.5,
  },
  subtitle2: {
    color: palette.text.secondary,
    fontWeight: 400,
    fontSize: "1.4rem",
    letterSpacing: "-0.05px",
    lineHeight: 2.1,
  },
  body1: {
    color: palette.text.primary,
    fontSize: "1.4rem",
    letterSpacing: "-0.05px",
    lineHeight: 2.1,
  },
  body2: {
    color: palette.text.secondary,
    fontSize: "1.2rem",
    letterSpacing: "-0.04px",
    lineHeight: 1.8,
  },
  button: {
    color: palette.text.primary,
    fontSize: "1.4rem",
  },
  caption: {
    color: palette.text.secondary,
    fontSize: "1.1rem",
    letterSpacing: "0.33px",
    lineHeight: 1.3,
  },
  overline: {
    color: palette.text.secondary,
    fontSize: "1.1rem",
    fontWeight: 500,
    letterSpacing: "0.33px",
    lineHeight: 1.3,
    textTransform: "uppercase",
  },

  // // Custom
  // charts: {
  //   legend: {
  //     fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
  //     fontWeight: 300,
  //     fontSize: "0.5rem",
  //     lineHeight: 1.167,
  //     letterSpacing: "-0.01562em",
  //     "@media (minWidth:600px)": { fontSize: "0.7129rem" },
  //     "@media (minWidth:960px)": { fontSize: "0.3556rem" },
  //     "@media (minWidth:1280px)": { fontSize: "0.9983rem" },
  //   },
};
